import { render, staticRenderFns } from "./WardrobeSummary.vue?vue&type=template&id=7d1caf3e&"
import script from "./WardrobeSummary.vue?vue&type=script&lang=js&"
export * from "./WardrobeSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports